// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ManagementSoftware_TheComp__BNXmK"};